import { h } from 'preact';
import { Text } from 'preact-i18n';
import { selectIcon } from '../templates/place';

const DateOption = ({ label, onClick, icon }) => {
  return (
    <button className="dates-controls-button" onClick={onClick}>
      {icon && (
        <div
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: selectIcon('calendar', false),
          }}
        />
      )}
      {label}
    </button>
  );
};

const DatesControls = ({ label, onDateClick, onTodayClick, onTomorrowClick }) => {
  return (
    <div className="dates-controls-container">
      <label className="label">{label}</label>
      <div className="dates-controls-wrapped">
        <DateOption label={<Text id="label.today" />} onClick={onTodayClick} />
        <DateOption label={<Text id="label.tomorrow" />} onClick={onTomorrowClick} />
        <DateOption label={<Text id="label.select" />} icon="calendar" onClick={onDateClick} />
      </div>
    </div>
  );
};

export default DatesControls;
